import React from 'react'
import { Button } from '@mui/material'
import { useLocation, useParams } from 'react-router-dom'
import { useState, useEffect } from 'react';
import Dialog from '@mui/material/Dialog';
import DeleteIcon from '@mui/icons-material/Delete';
import { DialogTitle, DialogActions } from '@mui/material';
import DialogContent from '@mui/material/DialogContent';
import Slide from '@mui/material/Slide';
import ChevronLeft from '@mui/icons-material/ChevronLeft';
import { useNavigate } from 'react-router-dom';
import { IconButton } from '@mui/material';
import noReports from '../Assets/images/No report image.png'
import ReportStore from '../DataRepository/Reports';
import { CircularProgress } from '@mui/material';
import { getDynamicLogo } from '../getDynamicLogo'
import { getUserDetails } from '../Auth/AuthUtil';
import LoadingComponent from "../loading"


const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

function Reports() {

    const { id } = useParams()
    const [open, setOpen] = useState(false);
    const location = useLocation();
    const [reports, setReports] = useState([])
    const [openDialog, setOpenDialog] = useState(false);
    const [selectedReportId, setSelectedReportId] = useState(null);

    const handleClickOpenDialog = (reportId) => {
        setSelectedReportId(reportId);
        setOpenDialog(true);
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
    };

    const confirmDelete = () => {
        handleDelete(selectedReportId);
        handleCloseDialog();
    };

    const { getReports, Reports, isReportsLoading, deletereport } = ReportStore()


    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const navigate = useNavigate()

    const handleDelete = async (id) => {
        deletereport(id)
    };

    useEffect(() => {
        getReports(id)
    }, [])

    const handleReportClick = (report) => {
        navigate(`/ViewReportList/${id}/${report?.id}`)
    };

    const [pathtype, setPathtype] = useState('none');

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        setPathtype(queryParams.get('type') || 'none');
    }, [location]);


    return <div className='All-products-section-main'>
        <nav className='flex flex-row p-2 items-center justify-between'>
            <div className='flex flex-row items-center'>
                <IconButton onClick={() => navigate(-1)}>
                    <ChevronLeft />
                </IconButton>
                <p className='mb-0'>Reports</p>
            </div>
            {Reports.length > 0 && (
                <Button
                    style={{
                        textTransform: 'none',
                        backgroundColor: 'var(--themePrimaryColor, #DA6E0B)',
                        color: 'white',
                        border: 'none',
                        borderRadius: '8px',
                        fontFamily: "'Poppins', sans-serif",
                        fontWeight: 500,
                        padding: '6px 16px',
                        fontSize: '13px',
                    }}
                    onClick={handleClickOpen}
                >
                    + Add Report
                </Button>
            )}
        </nav>
        {
            isReportsLoading ? <LoadingComponent loading={isReportsLoading} />
                :
                <div className='Reports-main-page'>
                    {Reports.length > 0 ?
                        <>
                            <div className='ListReports'>
                                {Reports.map((e, i) => {

                                    let formattedDate = '';
                                    try {
                                        const d = new Date(e.CreatedAt);
                                        if (!isNaN(d.getTime())) {
                                            formattedDate = new Intl.DateTimeFormat('en-IN', {
                                                day: '2-digit',
                                                month: 'short',
                                                year: 'numeric',
                                                hour: '2-digit',
                                                minute: '2-digit',
                                                hour12: true,
                                                timeZone: 'Asia/Kolkata',
                                            }).format(d);
                                        } else {
                                            formattedDate = e.CreatedAt || 'N/A';
                                        }
                                    } catch {
                                        formattedDate = e.CreatedAt || 'N/A';
                                    }

                                    const isDoctor = e.ReportUploadedby === getUserDetails().UID;

                                    return (
                                        <div
                                            key={e?.ReportId || i}
                                            onClick={() => handleReportClick(e)}
                                            style={{
                                                display: 'flex',
                                                flexDirection: 'column',
                                                border: '1px solid #E0DDD6',
                                                borderRadius: '12px',
                                                backgroundColor: '#FFFFFF',
                                                padding: '1rem',
                                                cursor: 'pointer',
                                                fontFamily: "'Poppins', sans-serif",
                                                position: 'relative',
                                                transition: 'box-shadow 0.2s ease, transform 0.15s ease',
                                                boxShadow: '0 1px 4px rgba(0,0,0,0.04)',
                                            }}
                                            onMouseEnter={(ev) => {
                                                ev.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.08)';
                                                ev.currentTarget.style.transform = 'translateY(-1px)';
                                            }}
                                            onMouseLeave={(ev) => {
                                                ev.currentTarget.style.boxShadow = '0 1px 4px rgba(0,0,0,0.04)';
                                                ev.currentTarget.style.transform = 'translateY(0)';
                                            }}
                                        >
                                            {/* Top row: icon + delete */}
                                            <div style={{
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'center',
                                                marginBottom: '0.75rem',
                                            }}>
                                                <div style={{
                                                    width: '40px',
                                                    height: '40px',
                                                    borderRadius: '8px',
                                                    backgroundColor: e.filetype === 'images' ? '#FFF3E6' : '#FEECEC',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                }}>
                                                    {e.filetype === 'images' ? (
                                                        <img src='/icons/Image icon-1.png' alt='Image'
                                                            style={{ width: '22px' }} />
                                                    ) : (
                                                        <img src='/icons/pdf icon.png' alt='PDF'
                                                            style={{ width: '22px' }} />
                                                    )}
                                                </div>
                                                <IconButton
                                                    size="small"
                                                    onClick={(ev) => {
                                                        ev.stopPropagation();
                                                        handleClickOpenDialog(e?.ReportId);
                                                    }}
                                                    sx={{
                                                        color: '#bbb',
                                                        '&:hover': { color: '#c62828', backgroundColor: '#fef2f2' },
                                                    }}
                                                >
                                                    <DeleteIcon fontSize='small' />
                                                </IconButton>
                                            </div>

                                            {/* Report type */}
                                            <p style={{
                                                margin: '0 0 4px 0',
                                                fontWeight: 600,
                                                fontSize: '14px',
                                                color: 'var(--themePrimaryColor, #3B362A)',
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                whiteSpace: 'nowrap',
                                            }}>
                                                {e.ReportType || 'Report'}
                                            </p>

                                            {/* Uploader badge */}
                                            <span style={{
                                                display: 'inline-block',
                                                fontSize: '11px',
                                                fontWeight: 500,
                                                color: isDoctor ? 'var(--themeSecondaryColor, #75623F)' : 'var(--themePrimaryColor, #DA6E0B)',
                                                backgroundColor: isDoctor ? '#F5F0E6' : '#FFF3E6',
                                                borderRadius: '4px',
                                                padding: '2px 8px',
                                                marginBottom: '8px',
                                                alignSelf: 'flex-start',
                                            }}>
                                                {isDoctor ? 'Uploaded by you' : 'Uploaded by patient'}
                                            </span>

                                            {/* Date */}
                                            <p style={{
                                                margin: 0,
                                                fontSize: '12px',
                                                color: '#999',
                                                fontWeight: 400,
                                            }}>
                                                {formattedDate}
                                            </p>
                                        </div>
                                    );
                                })}
                            </div>
                        </>
                        :
                        <div className='No-reports'>
                            <img src={noReports}></img>
                            <p>No health reports found</p>
                            <p>Please upload the patient's report to assist us in maintaining accurate and comprehensive patient records.</p>

                            <div className='flex items-center gap-5'>
                                <div>
                                    <Button
                                        style={{
                                            // width: '100%',
                                            textTransform: 'none',
                                            borderRadius: '0',
                                            backgroundColor: 'var(--themePrimaryColor, #DA6E0B)',
                                            color: 'white',
                                            border: 'none',
                                            boxSizing: 'border-box',
                                            borderRadius: "5px",
                                            fontFamily: "'Poppins', sans-serif",
                                            fontWeight: 500,
                                            padding: "10px"
                                        }}
                                        onClick={handleClickOpen}
                                    >
                                        Add a report
                                    </Button>
                                </div>

                                {pathtype === 'tele' && (
                                    <div>
                                        <Button
                                            style={{
                                                width: '100%',
                                                textTransform: 'none',
                                                borderRadius: '5px',
                                                border: '1px solid var(--themePrimaryColor, #DA6E0B)',
                                                color: 'var(--themePrimaryColor, #DA6E0B)',
                                                boxSizing: 'border-box',
                                                backgroundColor: "var(--themeSurfaceColor, #FDFDFD)",
                                                fontFamily: "'Poppins', sans-serif",
                                                fontWeight: 500,
                                                padding: '10px'
                                            }}
                                            onClick={() => navigate('/prakritiintro')}
                                        >
                                            Proceed to Prakriti
                                        </Button>
                                    </div>
                                )}



                            </div>
                        </div>
                    }

                    <Dialog

                        open={open}
                        TransitionComponent={Transition}
                        keepMounted
                        onClose={handleClose}
                        aria-describedby="alert-dialog-slide-description"
                    >
                        <DialogContent id="dialog">
                            <div className='dialog-content'>
                                <p>Select your report type</p>
                                <div className='dialog-action-items'>

                                    <div>
                                        <Button
                                            style={{
                                                width: '100%',
                                                textTransform: 'none',
                                                borderRadius: '0',
                                                border: "1px solid var(--themePrimaryColor, #3B362A)",
                                                backgroundColor: "#EFE3C2",
                                                color: 'var(--themePrimaryColor, #3B362A)',
                                                boxSizing: 'border-box',
                                                borderRadius: "5px",
                                                fontFamily: "'Poppins', sans-serif",
                                                fontWeight: 500,
                                                padding: "10px"
                                            }}

                                            onClick={() => {
                                                navigate(`/UploadReports/${id}/images`)
                                            }}
                                        >
                                            <div className='btn-content'>
                                                <img src='/icons/Image icon.png'></img>
                                                <p>Images</p>
                                            </div>
                                        </Button>
                                    </div>

                                    <div>
                                        <Button
                                            style={{
                                                width: '100%',
                                                textTransform: 'none',
                                                borderRadius: '0',
                                                border: "1px solid var(--themePrimaryColor, #3B362A)",
                                                backgroundColor: "#EFE3C2",
                                                color: 'var(--themePrimaryColor, #3B362A)',
                                                boxSizing: 'border-box',
                                                borderRadius: "5px",
                                                fontFamily: "'Poppins', sans-serif",
                                                fontWeight: 500,
                                                padding: "10px"
                                            }}

                                            onClick={() => {
                                                navigate(`/UploadReports/${id}/Document`)
                                            }}
                                        >
                                            <div className='btn-content'>
                                                <img src='/icons/pdf icon.png'></img>
                                                <p>Document</p>
                                            </div>
                                        </Button>
                                    </div>

                                </div>
                            </div>
                        </DialogContent>

                    </Dialog>

                    <Dialog
                        open={openDialog}
                        onClose={handleCloseDialog}
                        PaperProps={{
                            sx: {
                                borderRadius: '16px',
                                padding: '0.5rem',
                                maxWidth: '360px',
                                fontFamily: "'Poppins', sans-serif",
                            }
                        }}
                    >
                        <DialogContent sx={{ textAlign: 'center', pt: 3 }}>
                            <div style={{
                                width: '56px',
                                height: '56px',
                                borderRadius: '50%',
                                backgroundColor: '#FEF2F2',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                margin: '0 auto 1rem',
                            }}>
                                <DeleteIcon style={{ color: '#c62828', fontSize: '28px' }} />
                            </div>
                            <p style={{
                                margin: '0 0 0.25rem 0',
                                fontWeight: 600,
                                fontSize: '18px',
                                color: 'var(--themePrimaryColor, #3B362A)',
                                fontFamily: "'Poppins', sans-serif",
                            }}>Delete Report?</p>
                            <p style={{
                                margin: 0,
                                fontSize: '13px',
                                color: '#999',
                                fontFamily: "'Poppins', sans-serif",
                            }}>This action cannot be undone.</p>
                        </DialogContent>
                        <DialogActions sx={{ justifyContent: 'center', gap: '0.75rem', pb: 3, px: 3 }}>
                            <Button
                                onClick={handleCloseDialog}
                                variant="outlined"
                                fullWidth
                                sx={{
                                    textTransform: 'none',
                                    borderRadius: '10px',
                                    borderColor: '#E0DDD6',
                                    color: 'var(--themePrimaryColor, #3B362A)',
                                    fontFamily: "'Poppins', sans-serif",
                                    fontWeight: 500,
                                    padding: '10px',
                                    '&:hover': { borderColor: '#bbb', backgroundColor: '#FAFAF8' },
                                }}
                            >
                                Cancel
                            </Button>
                            <Button
                                onClick={confirmDelete}
                                variant="contained"
                                fullWidth
                                sx={{
                                    textTransform: 'none',
                                    borderRadius: '10px',
                                    backgroundColor: '#c62828',
                                    fontFamily: "'Poppins', sans-serif",
                                    fontWeight: 500,
                                    padding: '10px',
                                    boxShadow: 'none',
                                    '&:hover': { backgroundColor: '#b71c1c', boxShadow: 'none' },
                                }}
                            >
                                Delete
                            </Button>
                        </DialogActions>
                    </Dialog>

                </div>
        }

    </div >
}

export default Reports